import { supabase } from "./supabaseClient";

/* ──────────────── 📥 Fetch user's saved kanji ──────────────── */
export async function fetchSavedKanji(userId) {
  if (!userId) return [];
  try {
    const { data, error } = await supabase
      .from("saved_kanji")
      .select("kanji")
      .eq("user_id", userId);
    if (error) throw error;
    return data.map((row) => row.kanji);
  } catch (err) {
    console.error("❌ fetchSavedKanji failed:", err);
    return [];
  }
}

/* ──────────────── 💾 Save kanji ──────────────── */
export async function saveKanjiToSupabase(userId, kanji) {
  try {
    const { error } = await supabase
      .from("saved_kanji")
      .insert([{ user_id: userId, kanji }]);
    if (error) throw error;
    console.log(`✅ Saved ${kanji} for user ${userId}`);
    return true;
  } catch (err) {
    console.error("❌ saveKanjiToSupabase failed:", err);
    return false;
  }
}

/* ──────────────── 🗑️ Delete kanji ──────────────── */
export async function deleteKanjiFromSupabase(userId, kanji) {
  try {
    const { error } = await supabase
      .from("saved_kanji")
      .delete()
      .eq("user_id", userId)
      .eq("kanji", kanji);
    if (error) throw error;
    console.log(`🗑️ Deleted ${kanji} for user ${userId}`);
    return true;
  } catch (err) {
    console.error("❌ deleteKanjiFromSupabase failed:", err);
    return false;
  }
}
